export default function BurritoLogo({ className = "w-8 h-8" }) {
  return (
    <img
      src="https://customer-assets.emergentagent.com/job_tracko-memo/artifacts/6fok2c68_1000669598.png"
      alt="Taco Memo logo"
      className={className}
    />
  );
}
